const ar = {
  "nav.chefs": "طهاتنا",
  "nav.experiences": "التجارب",
  "nav.privateDining": "عشاء خاص",
  "nav.journal": "المجلة",
  "nav.howItWorks": "كيف يعمل",
  "nav.events": "الفعاليات",
  "nav.corporate": "الشركات",
  "nav.bespoke": "حسب الطلب",
  "nav.giftCards": "بطاقات الهدايا",
  "nav.becomeChef": "كن طاهياً",
  "nav.about": "من نحن",
  "nav.contact": "اتصل بنا",
  "nav.faq": "الأسئلة الشائعة",
  "nav.login": "تسجيل الدخول",
  "nav.logout": "تسجيل الخروج",
  "nav.account": "حسابي",
  "nav.findChef": "ابحث عن طاهيّ",
  "nav.more": "المزيد",

  "hero.line1": "مطبخ استثنائي.",
  "hero.line2": "في منزلك.",
  "hero.sub": "طهاة خاصون موثّقون يصنعون تجارب طعام من فئة الخمس نجوم في حميمية غرفة طعامك. في باريس وما بعدها.",
  "hero.badge": "كونسيرج الطهاة الخاصين",
  "search.location": "المدينة",
  "search.date": "التاريخ",
  "search.guests": "الضيوف",
  "search.cuisine": "المطبخ",
  "search.experience": "التجربة",
  "search.any": "الكل",
  "search.cta": "ابحث عن طاهيّ",

  "home.featuredEyebrow": "اختيار الدار",
  "home.featuredTitle": "طهاة من الطراز الرفيع",
  "home.viewAll": "استكشف جميع الطهاة",
  "home.expEyebrow": "تجارب مميزة",
  "home.expTitle": "ست طرق لعشاء استثنائي",
  "home.trustEyebrow": "وعدنا",
  "home.trustTitle": "كل طاهٍ، مُختار بعناية",
  "home.trustIntro": "خلف كل شارة «طاهٍ موثّق» تقف عملية تحقق مهنية صارمة. لا نقبل إلا الطهاة الذين يجتازون مراجعتنا الكاملة — لتبقى مائدتك دائماً بين أيدٍ خبيرة.",
  "trust.i1": "التحقق من الهوية (KYC)",
  "trust.i2": "مراجعة الخبرة المهنية",
  "trust.i3": "مراجعة الملف والأعمال",
  "trust.i4": "مراجعة ممارسات المطبخ",
  "trust.i5": "معايير تذوق الأطباق",
  "trust.i6": "وثائق النظافة المعمول بها",
  "trust.i7": "الامتثال المصرفي",
  "home.manifestoEyebrow": "البيان",
  "man.c1t": "المائدة مقدّسة",
  "man.c1b": "العشاء في المنزل ليس توصيل طعام. إنه فنّ وضيافة وحرفة — يُصاغ لمن تحب، في المكان الذي تحبه.",
  "man.c2t": "الحرفة قبل السهولة",
  "man.c2b": "طهاتنا يتسوقون من أسواق الصباح، يطهون في مطبخك ويقدمون طبقاً بعد طبق. لا شيء مُعاد تسخينه، لا شيء عادي.",
  "man.c3t": "ثقة موثّقة",
  "man.c3b": "كل طاهٍ في شيف آ دوميسيل يجتاز تحققاً مهنياً قبل تقديم أي طبق. التميّز هو شرط الدخول.",
  "home.marquee": "طاهٍ خاص في باريس — شيف آ دوميسيل — عشاء خاص فاخر — قوائم حسب الطلب — ضيافة خمس نجوم —",
  "home.ctaTitle": "مائدتك تستحق طاهياً.",
  "home.ctaBtn": "احجز تجربة",
  "home.journalEyebrow": "المجلة",
  "home.journalTitle": "حكايات من المائدة",

  "common.verified": "طاهٍ موثّق",
  "common.perGuest": "لكل ضيف",
  "common.from": "ابتداءً من",
  "common.viewProfile": "عرض الملف",
  "common.book": "احجز",
  "common.loading": "جارٍ التحميل…",
  "common.error": "حدث خطأ ما.",
  "common.retry": "إعادة المحاولة",
  "common.empty": "لا يوجد شيء هنا بعد.",
  "common.readMore": "اقرأ المزيد",
  "common.back": "رجوع",
  "common.send": "إرسال",
  "common.sending": "جارٍ الإرسال…",
  "common.yearsExp": "{n} سنوات خبرة",
  "common.reviews": "تقييمات",
  "common.languages": "اللغات",
  "common.all": "الكل",
  "common.cancel": "إلغاء",
  "common.save": "حفظ",
  "common.delete": "حذف",
  "common.add": "إضافة",
  "common.optional": "اختياري",
  "common.next": "متابعة",
  "common.confirm": "تأكيد",
  "common.total": "الإجمالي",
  "common.guests": "ضيوف",

  "chefs.title": "سوق الطهاة الموثّقين",
  "chefs.sub": "طهاة خاصون مميزون، موثّقون من فريقنا، جاهزون للطهي في منزلك.",
  "chefs.filters": "التصفية",
  "chefs.clear": "مسح التصفية",
  "chefs.cuisine": "المطبخ",
  "chefs.city": "المدينة",
  "chefs.minRating": "الحد الأدنى للتقييم",
  "chefs.maxPrice": "أقصى سعر / ضيف",
  "chefs.language": "لغة الطاهي",
  "chefs.noResults": "لا يوجد طهاة يطابقون هذه المعايير. وسّع نطاق بحثك.",
  "chefs.count": "{n} طاهٍ موثّق",

  "chef.about": "عن الطاهي",
  "chef.signature": "الأطباق المميزة",
  "chef.reviews": "تقييمات الضيوف",
  "chef.bookThis": "احجز هذا الطاهي",
  "chef.qualification": "المؤهلات",
  "chef.allergens": "مسببات الحساسية",
  "chef.dietary": "الأنظمة الغذائية",
  "chef.prep": "{n} دقيقة تحضير",

  "exp.title": "تجارب مميزة",
  "exp.sub": "ست طرق منتقاة لإحضار المطبخ الاستثنائي إلى منزلك — من عشاء حميم إلى حدث غاسترونومي حسب الطلب.",

  "booking.title": "احجز تجربتك",
  "booking.step1": "القائمة",
  "booking.step2": "التفاصيل",
  "booking.step3": "التأكيد والدفع",
  "booking.selectDish": "اختر طبقاً مميزاً",
  "booking.date": "التاريخ",
  "booking.time": "الوقت",
  "booking.address": "العنوان",
  "booking.city": "المدينة",
  "booking.occasion": "المناسبة",
  "booking.requests": "طلبات خاصة",
  "booking.create": "مراجعة حجزي",
  "booking.promo": "رمز خصم أو بطاقة هدية",
  "booking.promoApply": "تطبيق",
  "booking.promoApplied": "تم تطبيق الرمز",
  "booking.chef": "طاهيك",
  "booking.pricePerGuest": "السعر لكل ضيف",
  "booking.pay": "المتابعة إلى الدفع الآمن",
  "booking.payNote": "سيتم توجيهك إلى صفحة دفع آمنة عبر Stripe. المبلغ النهائي يُحتسب من قبل خدمتنا.",
  "booking.loginFirst": "يرجى تسجيل الدخول لإتمام حجزك.",
  "booking.stripeOff": "الدفع عبر الإنترنت غير متاح مؤقتاً. تم حفظ حجزك — سيتواصل معك الكونسيرج لإتمام الدفع.",
  "booking.discount": "الخصم",

  "pay.checking": "جارٍ تأكيد الدفع…",
  "pay.success": "تم تأكيد الدفع. تم إبلاغ طاهيك — نلقاكم على المائدة.",
  "pay.failed": "لم يكتمل الدفع.",
  "pay.pending": "الدفع قيد المعالجة. ستتحدث هذه الصفحة تلقائياً.",
  "pay.backAccount": "الذهاب إلى حجوزاتي",

  "auth.loginTitle": "أهلاً بعودتك",
  "auth.registerTitle": "أنشئ حسابك",
  "auth.email": "البريد الإلكتروني",
  "auth.password": "كلمة المرور",
  "auth.name": "الاسم الكامل",
  "auth.loginBtn": "تسجيل الدخول",
  "auth.registerBtn": "إنشاء حساب",
  "auth.toRegister": "جديد على شيف آ دوميسيل؟ أنشئ حساباً",
  "auth.toLogin": "عضو بالفعل؟ سجّل الدخول",

  "account.title": "حسابي",
  "account.bookings": "الحجوزات",
  "account.favorites": "المفضلة",
  "account.giftcards": "بطاقات الهدايا",
  "account.dietary": "الملف الغذائي",
  "account.addresses": "العناوين",
  "account.noBookings": "لا حجوزات بعد. عشاؤك الاستثنائي القادم بانتظارك.",
  "account.noFavorites": "لا طهاة مفضلين بعد.",
  "account.status": "الحالة",
  "account.cancelBooking": "إلغاء الحجز",
  "account.review": "اترك تقييماً",
  "account.reviewComment": "تعليقك",
  "account.messages": "الرسائل",
  "account.writeMsg": "اكتب رسالة لطاهيك…",
  "account.allergies": "الحساسية",
  "account.diets": "الأنظمة والتفضيلات",
  "account.saveProfile": "حفظ الملف",
  "account.addAddress": "إضافة عنوان",
  "account.label": "التسمية (المنزل، المكتب…)",
  "account.noGiftcards": "لا طلبات بطاقات هدايا بعد.",
  "account.commaHint": "افصل بفواصل",

  "gift.title": "هدية مائدة لا تُنسى",
  "gift.sub": "اهدِ تجربة طاهٍ خاص. يتلقى المُهدى إليه بطاقة هدية أنيقة، قابلة للاستخدام في أي حجز.",
  "gift.amount": "المبلغ (25 € – 1000 €)",
  "gift.recipientName": "اسم المستلم",
  "gift.recipientEmail": "بريد المستلم",
  "gift.message": "رسالة شخصية",
  "gift.buy": "شراء بطاقة الهدية",
  "gift.note": "يُنشأ رمز البطاقة ويُرسل بالبريد فقط بعد تأكيد الدفع.",

  "becomeChef.title": "اطبخ لأجمل الموائد",
  "becomeChef.sub": "انضم إلى شيف آ دوميسيل كطاهٍ خاص. قوائمك، أسعارك، جدولك — ونحن نأتيك بعملاء مميزين.",
  "becomeChef.cta": "قدّم كطاهٍ",
  "becomeChef.bio": "قصتك وخلفيتك الطهوية",
  "becomeChef.years": "سنوات الخبرة",
  "becomeChef.qualification": "المؤهل / التدريب",
  "becomeChef.city": "المدينة",
  "becomeChef.cuisines": "مطابخك",
  "becomeChef.success": "تم استلام طلبك. يدخل ملفك الآن مسار التحقق المهني — سيتواصل معك فريقنا.",
  "becomeChef.s1t": "قدّم",
  "becomeChef.s1b": "حدّثنا عن خبرتك وتدريبك ومطبخك المميز.",
  "becomeChef.s2t": "اجتز التحقق",
  "becomeChef.s2b": "تُراجع الهوية والخبرة وممارسات المطبخ والأعمال مهنياً.",
  "becomeChef.s3t": "اطبخ واربح",
  "becomeChef.s3b": "استقبل حجوزات من عملاء راقين واحصل على مستحقاتك بأمان.",

  "inquiry.contactTitle": "تواصل مع الدار",
  "inquiry.contactSub": "سؤال، مشروع، طلب خاص — الكونسيرج يرد خلال 24 ساعة.",
  "inquiry.corporateTitle": "تجارب الشركات",
  "inquiry.corporateSub": "عشاءات تنفيذية، ضيافة عملاء، احتفالات فرق — مطبخ يليق باسم شركتك.",
  "inquiry.corporateCta": "اطلب تجربة شركات",
  "inquiry.eventsTitle": "فعاليات بكل المقاييس",
  "inquiry.eventsSub": "أعياد ميلاد، أعراس، حفلات استقبال — إنتاج طهوي متكامل، من القائمة إلى الخدمة.",
  "inquiry.eventsCta": "خطط لفعاليتي",
  "inquiry.bespokeTitle": "قوائم حسب الطلب بالكامل",
  "inquiry.bespokeSub": "قائمة فريدة تُصمَّم مع طاهيك حول قصتك ومنتجاتك ومناسبتك.",
  "inquiry.bespokeCta": "ابدأ مشروعاً حسب الطلب",
  "inquiry.eventType": "نوع الفعالية",
  "inquiry.budget": "الميزانية",
  "inquiry.location": "المكان",
  "inquiry.company": "الشركة",
  "inquiry.phone": "الهاتف",
  "inquiry.date": "التاريخ المطلوب",
  "inquiry.guests": "الضيوف",
  "inquiry.message": "رسالتك",
  "inquiry.success": "شكراً لك. سيتواصل معك فريق الكونسيرج قريباً.",

  "how.title": "كيف يعمل",
  "how.sub": "من أول نقرة إلى آخر طبق — بلا عناء، في أربع حركات.",
  "how.s1t": "01 — كوّن",
  "how.s1b": "اختر مدينتك والتاريخ والضيوف والمطبخ. تصفح الطهاة الموثّقين وأطباقهم المميزة.",
  "how.s2t": "02 — احجز",
  "how.s2b": "احجز في دقائق. السعر يُحتسب بشفافية لكل ضيف — بلا رسوم خفية.",
  "how.s3t": "03 — استقبل طاهيك",
  "how.s3b": "يصل طاهيك بمنتجات طازجة، يطهو في مطبخك ويقدم طبقاً بعد طبق.",
  "how.s4t": "04 — استمتع فحسب",
  "how.s4b": "يترك طاهيك المطبخ نظيفاً تماماً. تحتفظ أنت بالذكريات — والمجاملات.",

  "about.title": "الدار",
  "about.p1": "وُلد شيف آ دوميسيل من قناعة بسيطة: أجمل مطعم في العالم هو منزلك. نصل المضيفين المميزين بطهاة خاصين موثّقين يحوّلون غرفة الطعام إلى مائدة خمس نجوم.",
  "about.p2": "من باريس وما بعدها، ينتقي سوقنا الراقي طهاة عبر 28 مطبخاً عالمياً — كل منهم مُتحقق منه مهنياً: الهوية والخبرة وممارسات المطبخ والأعمال، قبل أن يرتدي المئزر من أجلك.",
  "about.p3": "لسنا توصيل طعام. نحن الضيافة — فنّ المائدة، يعود إلى البيت.",

  "privateDining.title": "العشاء الخاص، بإتقان",
  "privateDining.sub": "عشاءات حميمة من 2 إلى 20 ضيفاً، ينظمها طاهٍ خاص موثّق.",
  "privateDining.p1": "تبدأ الأمسية مع شيف آ دوميسيل قبل الطبق الأول بكثير. يصمم طاهيك القائمة معك، ينتقي أفضل منتجات الصباح ويصل جاهزاً لتحويل مطبخك إلى مطبخ دار عريقة.",
  "privateDining.p2": "تتوالى الأطباق على مائدتك — بينما تبقى مع ضيوفك. وفي نهاية السهرة، يُترك المطبخ نظيفاً تماماً.",
  "privateDining.cta": "ابحث عن طاهٍ لعشائي",

  "faq.title": "الأسئلة الشائعة",
  "faq.q1": "كيف يتم التحقق من الطهاة؟",
  "faq.a1": "يجتاز كل طاهٍ تحققاً مهنياً: الهوية (KYC)، الخبرة المهنية، مراجعة الملف، مراجعة ممارسات المطبخ، أعمال الأطباق، وثائق النظافة المعمول بها والامتثال المصرفي. لا يظهر في السوق إلا الطهاة الموثّقون.",
  "faq.q2": "ماذا يشمل السعر لكل ضيف؟",
  "faq.a2": "تسوق الطاهي، التحضير، الطهي، خدمة المائدة وتنظيف المطبخ. يُحتسب الإجمالي بشفافية من قبل خدمتنا عند الحجز.",
  "faq.q3": "هل تتكيف القوائم مع الحساسية أو الأنظمة الغذائية؟",
  "faq.a3": "نعم. احفظ حساسياتك وتفضيلاتك في ملفك الغذائي وأضف طلبات خاصة لأي حجز — يكيّف طاهيك القائمة.",
  "faq.q4": "كيف يتم الدفع؟",
  "faq.a4": "تُعالج المدفوعات بأمان عبر Stripe. لا تُخصم إلا عند تأكيد الحجز؛ تُطبَّق بطاقات الهدايا ورموز الخصم قبل الدفع.",
  "faq.q5": "هل يمكنني إلغاء حجز؟",
  "faq.a5": "نعم، من حسابك. راجع سياسة الإلغاء للشروط حسب مدة الإشعار.",

  "journal.title": "المجلة",
  "journal.sub": "الغاسترونومية وفن الضيافة وفن المائدة — من شيف آ دوميسيل.",
  "journal.empty": "حكايات جديدة تُكتب الآن. عد قريباً.",
  "journal.related": "حكايات ذات صلة",

  "legal.termsTitle": "شروط الخدمة",
  "legal.privacyTitle": "سياسة الخصوصية",
  "legal.cancelTitle": "سياسة الإلغاء",
  "legal.terms1": "يدير شيف آ دوميسيل سوقاً يربط العملاء بطهاة خاصين مستقلين وموثّقين. باستخدامك chef-adomicile.com فأنت تقبل هذه الشروط. يشكّل الحجز عقداً بين العميل والطاهي، تُيسّره المنصة.",
  "legal.terms2": "تُعرض الأسعار لكل ضيف؛ يُحتسب الإجمالي النهائي من قبل خدمتنا عند الحجز. يُعالج الدفع عبر شريكنا الآمن. الطهاة مهنيون مستقلون مسؤولون عن الخدمة الطهوية المقدمة.",
  "legal.terms3": "جميع المحتويات والعلامات والصور على هذا الموقع ملك لشيف آ دوميسيل. قد يؤدي سوء استخدام المنصة أو الحجوزات الاحتيالية إلى تعليق الحساب.",
  "legal.privacy1": "نجمع فقط البيانات اللازمة لحسابك وحجوزاتك: الهوية، بيانات الاتصال، العناوين، التفضيلات الغذائية وسجل الحجوزات. لا نبيع بياناتك أبداً.",
  "legal.privacy2": "بيانات الدفع تُعالج حصرياً من قبل شريك الدفع؛ لا يخزّن شيف آ دوميسيل أرقام البطاقات أبداً. لا يتلقى الطهاة إلا المعلومات اللازمة لتجربتك.",
  "legal.privacy3": "يمكنك طلب الوصول إلى بياناتك الشخصية أو تصحيحها أو حذفها في أي وقت عبر صفحة الاتصال.",
  "legal.cancel1": "يمكنك إلغاء حجز من حسابك. تُسترد الإلغاءات ذات الإشعار الكافي وفق الشروط المبلغة عند الحجز.",
  "legal.cancel2": "قد تترتب رسوم على الإلغاءات المتأخرة، إذ يكون الطاهي قد اشترى المنتجات وحجز التاريخ. تُعاد مدفوعات بطاقات الهدايا إلى البطاقة.",
  "legal.cancel3": "إذا اضطر طاهٍ للإلغاء، يقترح الكونسيرج طاهياً موثّقاً مكافئاً أو استرداداً كاملاً، حسب اختيارك.",

  "footer.tag": "مطبخ استثنائي. في منزلك.",
  "footer.explore": "استكشف",
  "footer.company": "الدار",
  "footer.legal": "قانوني",
  "footer.rights": "© 2026 Chef à Domicile — Tous droits réservés / جميع الحقوق محفوظة",

  "seo.homeTitle": "شيف آ دوميسيل — طاهٍ خاص في منزلك | عشاء خاص فاخر",
  "seo.homeDesc": "احجز طاهياً خاصاً موثّقاً لعشاء استثنائي في المنزل. عشاء خاص فاخر في باريس وما بعدها — قوائم حسب الطلب وفعاليات وتجارب شركات.",
};
export default ar;
